/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on
 * an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { ReactNode } from 'react';
import { PopoverProps } from 'antd/lib/popover';
import { ControlComponentProps } from '@superset-ui/chart-controls';

// 链接类型：超链接或图片
export enum LINK_TYPE {
  LINK = '超链接',
  IMAGE = '图片',
}

// 图片覆盖形式
export enum OBJECT_FIT {
  COVER = 'cover',
  CONTAIN = 'contain',
  FILL = 'fill',
  NONE = 'none',
  SCALE_DOWN = 'scale-down',
}

export interface LinkFormattingRule {
  column?: string;
  linkType: LINK_TYPE;
  // 超链接类型：显示的文本内容
  displayText?: string;
  // 图片类型：宽度、高度、圆角、覆盖形式
  imageWidth?: number;
  imageHeight?: number;
  imageBorderRadius?: number;
  objectFit?: OBJECT_FIT;
}

export type LinkFormattingControlProps = ControlComponentProps<
  LinkFormattingRule[]
> & {
  columnOptions: { label: string; value: string }[];
  removeIrrelevantConditions: boolean;
  verboseMap: Record<string, string>;
  label: string;
  description: string;
};

export type LinkFormattingPopoverProps = PopoverProps & {
  columns: { label: string; value: string }[];
  onChange: (value: LinkFormattingRule) => void;
  config?: LinkFormattingRule;
  title: string;
  children: ReactNode;
};
